import React, { useState, useEffect, Suspense, lazy } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollTop";

import "react-whatsapp-widget/dist/index.css";
import { WhatsAppWidget } from "react-whatsapp-widget";
import TopBar from "./components/TopBar";
import Loading from "./assets/loading.svg";
const Home = lazy(() => import("./pages/Home/Home"));
const AboutUs = lazy(() => import("./pages/AboutUs"));
const Services = lazy(() => import("./pages/Services"));
const ContactUs = lazy(() => import("./pages/ContactUs"));
const Quote = lazy(() => import("./pages/Quote"));
const Decor = lazy(() => import("./pages/ServicesPage/Decor"));
const Catering = lazy(() => import("./pages/ServicesPage/Catering"));
const Photography = lazy(() => import("./pages/ServicesPage/Photography"));
const Entertainment = lazy(() => import("./pages/ServicesPage/Entertainment"));
const Venue = lazy(() => import("./pages/ServicesPage/Venue"));
const Corporate = lazy(() => import("./pages/ServicesPage/Corporate"));
const Haldi = lazy(() => import("./pages/ServicesPage/Haldi"));
const Sangeet = lazy(() => import("./pages/ServicesPage/Sangeet"));
const OtherServices = lazy(() => import("./pages/ServicesPage/OtherServices"));

function App() {
  const [isTopBarVisible, setIsTopBarVisible] = useState(true);
  const location = useLocation();

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      setIsTopBarVisible(window.scrollY < lastScrollY);
      lastScrollY = window.scrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    // Log page view on route change
    ReactGA.send({ hitType: "pageview", page: location?.pathname });
  }, [location]);

  return (
    <div className="container mx-auto">
      <ScrollToTop />
      {/* WhatsApp Widget */}
      <div className="fixed bottom-4 right-4 z-50">
        <WhatsAppWidget
          phoneNumber="+918883666618"
          message="Hello! How can I help you?"
        />
      </div>

      <TopBar isVisible={isTopBarVisible} />
      <Navbar isTopBarVisible={isTopBarVisible} />
      <Suspense
        fallback={
          <div className="min-h-screen bg-gray-900 flex items-center justify-center">
            <img
              className="w-40 h-40 object-contain"
              src={Loading}
              alt="loading"
            />
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/quote" element={<Quote />} />

          {/* Services Routes */}
          <Route path="/services/decor" element={<Decor />} />
          <Route path="/services/catering" element={<Catering />} />
          <Route path="/services/photography" element={<Photography />} />
          <Route path="/services/entertainment" element={<Entertainment />} />
          <Route path="/services/haldi" element={<Haldi />} />
          <Route path="/services/sangeet" element={<Sangeet />} />
          <Route path="/services/venue" element={<Venue />} />
          <Route path="/services/corporate" element={<Corporate />} />
          <Route path="/services/other_services" element={<OtherServices />} />

          <Route path="*" element={<Home />} />
        </Routes>
      </Suspense>
      <Footer />
    </div>
  );
}

export default App;
